import PropTypes from 'prop-types';
import React from 'react';

import _ from 'lodash';
import { DefaultSheet, SheetBody, SheetFooter, FormGroup, Label, Input, Button, Select, Row, Col } from 'twyne-new.ui';

import SelectTimeZone from 'components/form/SelectTimeZoneInput';
import appStore from 'stores/app';

const propTypes = {
  isOpen: PropTypes.bool,
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  search: PropTypes.string,
  onChangeSearch: PropTypes.func,
  params: PropTypes.object,
};

class ReportsFailureFilter extends React.Component {
  state = {
    params: {},
  }

  componentWillMount () {
    this.setState({params: _.cloneDeep(this.props.params)});
  }

  handleChangeTimezone = (value) => {
    let params = this.state.params;
    params.timeZone = value;
    this.setState({params});
  }

  handleChangeSite = (value) => {
    let params = this.state.params;
    params.siteId = value;
    this.setState({params});
  }

  siteOptions = () => {
    const opts = appStore.sites.map(site => ({ value: site.id, label: site.name }));

    return opts;
  }

  render() {
    if (!this.props.isOpen) {
      return null;
    }

    return (
      <DefaultSheet
        title="Filter"
        wrapperProps={{ open: this.props.isOpen, onOpenChange: this.props.onClose }}
      >
        <SheetBody>
          <Row>
            <Col>
              <FormGroup>
                <Label>Search</Label>
                <Input placeholder="Search..." value={this.props.search}
                  onChange={e => this.props.onChangeSearch(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label>Site</Label>
                <Select
                  options={this.siteOptions()}
                  name="siteId"
                  placeholder="Select site"
                  value={this.state.params.siteId}
                  onChange={opt => this.handleChangeSite(opt ? opt.value : null)}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label>Timezone</Label>
                <SelectTimeZone
                  value={this.state.params.timeZone}
                  onChange={opt => this.handleChangeTimezone(opt ? opt.value : null)}
                  placeholder="Organizations timezone"
                />
              </FormGroup>
            </Col>
          </Row>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.props.onClose} variant='ghost'>Cancel</Button>
          <Button onClick={() => this.props.onApply(this.state.params)} color="accent">Apply</Button>
        </SheetFooter>
      </DefaultSheet>
    );
  }
}

ReportsFailureFilter.propTypes = propTypes;

export default ReportsFailureFilter;
